'use strict';

var SoaModel = require('bunsen/models/SoaModel.js');
var ends = require('dibs-endpoints');
var _ = require('underscore');
var NO = 'N';
var YES = 'Y';

/**
 * Mailer model is sed to add an item to the mailer or remove an item from the mailer
 * @extends SoaModel
 */
var StorefrontPreferences = SoaModel.extend({
    initialize: function(attrs, options) {
        options = options || {};
        StorefrontPreferences.__super__.initialize.call(this, attrs, options);
        this.itemId = options.itemId;
    },
    url: function() {
        console.assert(this.itemId, 'StorefrontPreferences requires itemId to generate URL');
        return ends.itemStorefrontPreferences(this.itemId);
    },
    hideWhenSold: function(options) {
        return this.save({ showOnStorefrontWhenSold: NO }, _.extend({ type: 'PUT' }, options));
    },
    showWhenSold: function(options) {
        return this.save({ showOnStorefrontWhenSold: YES }, _.extend({ type: 'PUT' }, options));
    }
});

module.exports = StorefrontPreferences;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/StorefrontPreferences.js
// module id = 2055
// module chunks = 63